// extracted by mini-css-extract-plugin
export default {"flex-column":"card_flex-column__f9Etd","card":"card_card__Trs7t","flex-row":"card_flex-row__D40t5","page-size":"card_page-size__9zRkC"};